export function zip(a, b) {
    return a.map((a, i) => [a, b[i]]);
}